import { otherTeam, type LaunchSide, type TeamId } from "@scb/protocol";

/**
 * 자리 배정 — 대전에서 두 팀은 **왼쪽/오른쪽에 고정**되고 라운드마다 교대한다.
 *
 * ```
 *   1라운드         2라운드 (교대)
 *   ┌────┬────┐    ┌────┬────┐
 *   │팀0 │팀1 │    │팀1 │팀0 │
 *   └────┴────┘    └────┴────┘
 *    왼쪽  오른쪽    왼쪽  오른쪽
 * ```
 *
 * 빗이 테이블 가운데 정렬이라 자리가 고정되면 각 팀은 **자기 쪽 통로로만**
 * 뱅크샷을 칠 수 있다. 좌우 통로가 완전히 대칭이라 유불리는 없지만, 그래도
 * 교대를 두는 이유는 테이블 개체차(경사·마찰 편차)와 남은 공 배치의 누적 때문이다.
 *
 * 연장(roundCount + 1 라운드)도 같은 공식을 그대로 따른다 — 홀수 라운드는 팀0이 왼쪽.
 */
export function launchSideFor(round: number, team: TeamId): LaunchSide {
  const leftTeam = teamOnSide(round, "left");
  return team === leftTeam ? "left" : "right";
}

/** 그 라운드에 해당 자리를 쓰는 팀. */
export function teamOnSide(round: number, side: LaunchSide): TeamId {
  // 홀수 라운드(1, 3, …) → 팀0이 왼쪽. 짝수 라운드 → 교대.
  const left: TeamId = round % 2 === 1 ? 0 : 1;
  return side === "left" ? left : otherTeam(left);
}

/**
 * 라운드 선공 팀 — 공식 규칙의 "**오른쪽 플레이어부터** 시작" (docs §2).
 *
 * 자리가 라운드마다 바뀌므로 선공도 자동으로 번갈아 간다.
 * 선공을 자리에서 유도하기 때문에 둘이 어긋날 일이 없다.
 */
export function firstShooterTeam(round: number): TeamId {
  return teamOnSide(round, "right");
}
